import { ShippingItem } from '@shared/models/shipping-item.model';
import { DeliveryOptionDetails } from '../../models/delivery-options.model';

export class AddShippingItemAction {
  static readonly type = '[Logistics] Add shipping item';
  constructor(public shippingItem: ShippingItem) {}
}

export class AddOrUpdateShippingItemAction {
  static readonly type = '[Logistics] Add or update shipping item';
  constructor(public shippingItem: ShippingItem) {}
}

export class UpdateShippingItemAction {
  static readonly type = '[Logistics] Update shipping item';
  constructor(public shippingItem: ShippingItem) {}
}

export class RemoveShippingItemAction {
  static readonly type = '[Logistics] Remove shipping item';
  constructor(
    public id: string,
    public type: string
  ) {}
}

export class ApiGetDeliveryOptionsAction {
  static readonly type = '[Api] Get delivery options';
}

export class ApiGetDeliveryOptionsSuccessAction {
  static readonly type = '[Api] Get delivery options success';
  constructor(public deliveryOptions: DeliveryOptionDetails[]) {}
}
export class ApiGetDeliveryOptionsErrorAction {
  static readonly type = '[Api] Get delivery options error';
  constructor(public offeringIds: string[]) {}
}

export class SetSelectedDeliveryOptionAction {
  static readonly type = '[Logistics] Set selected delivery option';
  constructor(
    public deliveryOptionId: string,
    public offeringId: string
  ) {}
}

export class LogisticsResetAction {
  public static readonly type = '[Logistics] Reset logistics state';
}
